import { render, staticRenderFns } from "./TianMuPlayer.vue?vue&type=template&id=4c31472d&scoped=true"
import script from "./TianMuPlayer.vue?vue&type=script&lang=js"
export * from "./TianMuPlayer.vue?vue&type=script&lang=js"
import style0 from "./TianMuPlayer.vue?vue&type=style&index=0&id=4c31472d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_prettier@2.8.8_vue-template-compiler@2.7.16_webpack@5.101.3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c31472d",
  null
  
)

export default component.exports